import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'

import theme from './theme'
import SurveyInformation from './pages/products/SurveyInformation'
import LoginInvited from './pages/login/LoginInvited'
import { AuthProvider } from './context/AuthContext'
import PrivateRoute from './layouts/PrivateRoute'
import Error404 from './pages/error/Error404'
import Details from './pages/products/Details'
import Success from './pages/products/Success'
import Products from './pages/products/Products'
import Login from './pages/login/Login'
import CreateAccount from './pages/register/CreateAccount'
import RegisterSuccess from './pages/register/RegisterSuccess'
import Home from './pages/home/Home'
import ProductosPorArea from './pages/home/ProductosPorArea'
import ProtectedRoute from './layouts/ProtectedRoute'
import VerifyEmail from './pages/register/VerifyEmail'
import ConfirmSucces from './pages/register/ConfirmSucces'
import EditarProductosPorArea from './pages/home/EditarProductosPorArea'
import ResendEmailPassword from './pages/recovery/ResendEmailPassword'
import ValidateEmail from './pages/recovery/ValidateEmail'
import PasswordRecovery from './pages/recovery/PasswordRecovery'
import PasswordSuccess from './pages/recovery/PasswordSuccess'
import ChannelManagement from './pages/gestion/ChannelManagement'
import BottlerManagement from './pages/gestion/BottlerManagement'
import DistributorManagement from './pages/gestion/DistributorManagement'
import BattlefieldManagement from './pages/gestion/BattlefieldManagement'
import AreaManagement from './pages/gestion/AreaManagement'
import AttributesManagement from './pages/gestion/AttributesManagement'
import BrandManagement from './pages/gestion/BrandManagement'
import MaterialManagement from './pages/gestion/MaterialManagement'
import VolumeManagement from './pages/gestion/VolumeManagement'
import ProductManagement from './pages/gestion/ProductManagement'
function App () {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route exact element={<CreateAccount />} path='/create-account' />
            <Route exact element={<VerifyEmail />} path='/verify-email' />
            <Route element={<RegisterSuccess />} path='/register-success' />
            <Route element={<ConfirmSucces />} path='/confirm-success' />
            <Route element={<ValidateEmail />} path='/validate-email' />
            <Route element={<ResendEmailPassword />} path='/resend-email' />
            <Route element={<PasswordRecovery />} path='/password-recovery' />
            <Route element={<PasswordSuccess />} path='/success-recovery' />

            <Route element={<Login />} path='/' />
            <Route element={<ProtectedRoute />}>
              <Route element={<Home />} path='/home' />
              <Route element={<ProductosPorArea />} path='/products-area'/>
              <Route element={<EditarProductosPorArea />} path='/edit-products-area'/>
              <Route element={<DistributorManagement />} path='/distributor-management'/>
              <Route element={<BattlefieldManagement />} path='/battlefield-management'/>
              <Route element={<AreaManagement />} path='/area-management'/>
              <Route element={<AttributesManagement />} path='/attributes-management'/>
              <Route element={<MaterialManagement />} path='/material-management'/>
              <Route element={<BrandManagement />} path='/brand-management'/>
              <Route element={<VolumeManagement />} path='/volume-management'/>
              <Route element={<ChannelManagement />} path='/channel-management'/>
              <Route element={<BottlerManagement />} path='/bottler-management'/>
              <Route element={<ProductManagement />} path='/products-management'/>
            </Route>

            <Route exact element={<LoginInvited />} path='/login-invited'/>
            <Route element={<PrivateRoute />}>
              <Route element={<SurveyInformation />} path='/survey-information'/>
              <Route element={<Details />} path='/details'/>
              <Route element={<Success />} path='/success'/>
              <Route element={<Products />} path='/products'/>
            </Route>
            <Route element={<Error404 />} path='*'/>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  )
}

export default App
